/**
 * The simulation constants module houses simulation-specific configurations.
 *
 * @module routes.simulation.constants
 */

angular.module('routes.simulation.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var simulation;

      // Set defaults.
      simulation = {};

      /**
       * Defines simulation constants.
       *
       * @attribute SIMULATION
       * @type String
       * @readOnly
       */
      $provide.constant('SIMULATION', simulation);
    }
  ]);
